module.exports = __webpack_public_path__ + "static/media/image1.73cee87d.jpeg";